export const clientsData = [
  {
    id: 1,
    imageSrc: "/img/clients1.png",
    name: "Spartan India PVT LTD",
  },
  {
    id: 2,
    imageSrc: "/img/clients2.png",
    name: "Transcal Technologies LLP",
  },
  {
    id: 3,
    imageSrc: "/img/clients3.png",
    name: "Chavanke Engineering Pvt. Ltd.",
  },
  {
    id: 4,
    imageSrc: "/img/clients4.png",
    name: "Accurate Services & Enterprises",
  },
  {
    id: 5,
    imageSrc: "/img/client5.png",
    name: "HAL ",
  },
  {
    id: 6,
    imageSrc: "/img/client6.png",
    name: "Air Force School",
  },
  {
    id: 7,
    imageSrc: "/img/client7.png",
    name: "Webasto",
  },
];

export const galleryData = [
  {
    id: 15,
    imageSrc: "/img/gallery20.jpg",
    name:"gallery19.jpg"
  },
  {
    id: 9,
    imageSrc: "/img/gallery19.jpg",
    name:"gallery19.jpg"
  },
  {
    id: 10,
    imageSrc: "/img/gallery14.jpg",
    name:"gallery14.jpg"
  },
  {
    id: 11,
    imageSrc: "/img/gallery15.jpg",
    name:"gallery15.jpg"
  },
  {
    id: 12,
    imageSrc: "/img/gallery16.jpg",
    name:"gallery16.jpg"
  },
  {
    id: 13,
    imageSrc: "/img/gallery17.jpg",
    name:"gallery17.jpg"
  },
  {
    id: 14,
    imageSrc: "/img/gallery18.jpg",
    name:"gallery18.jpg"
  },
  {
    id: 1,
    imageSrc: "/img/Gallery1.jpg",
    name:"Gallery1.jpg"
  },
  {
    id: 2,
    imageSrc: "/img/Gallery2.jpg",
    name:"Gallery2.jpg"
  },
  {
    id: 3,
    imageSrc: "/img/Gallery3.jpg",
    name:"Gallery3.jpg"
  },
  {
    id: 4,
    imageSrc: "/img/Gallery4.jpg",
    name:"Gallery4.jpg"
  },
  {
    id: 5,
    imageSrc: "/img/Gallery5.jpg",
    name:"Gallery5.jpg"
  },
  {
    id: 6,
    imageSrc: "/img/Gallery6.jpg",
    name:"Gallery6.jpg"
  },
  {
    id: 7,
    imageSrc: "/img/gallery11.jpg",
    name:"gallery11.jpg"
  },
];

export const ourService = [
  {
    id: 1,
    image: "/img/service1.png",
    title: "Custom Software Development",
    description:
      "Our Specialised Customized Software Development is the process of Designing, Building, Deploying, and Maintaining Software for all types of SMEs and MSMEs that is tailored to their needs and aims",
  },
  {
    id: 2,
    image: "/img/service2.png",
    title: "App Development",
    description:
      "Our Application Development assist you in creating beneficial and efficient experiences on every device and help you get the most out of Mobile Technology for your business with our Application",
  },
  {
    id: 3,
    image: "/img/service3.png",
    title: "E-Commerce Solutions",
    description:
      "Our E-Commerce Software facilitates quicker and trusted growth of income and profit for both, beginner's playground, and an expert home field by meeting the demands of any small- to medium-sized firm.",
  },
  {
    id: 4,
    image: "/img/service4.png",
    title: "Software Consulting      ",
    description:
      "Trigun Software Consulting services diagnose, analyze, identify, plan, and offer solutions that are compatible with every organization's needs. Expertizing our knowledge and experience at all instances accelerates   ",
  },
  {
    id: 5,
    image: "/img/service5.png",
    title: "Cyber Secuirty",
    description:
      "To guarantee that your Systems and Data are safe, Trigun Cyber Security Employs a Patented Technique to execute a controlled external real-life evaluation and penetration test of your firewalls, Network",
  },
];

export const prductData = [
  {
    id: 1,
    image: "/img/product1.webp",
    title: "Measuring Instruments",
    description:
      "Manufacturer of a wide range of products which include e1 class weight box, decade inductance box, f1 class weight box, mitutoyo vernier caliper ., ultrasonic thickness gauges . and slip gauge accessories set.",
    subpoints:
      "1. We are one of the major names in the industry engaged in offering E1 Class Weights to the clients. The offered E2 class weights are commonly used in the calibration of weights related to lower accuracy class and for use with weighing instruments related to class I. 3.No. of Weights : 23 .4.Content : 1mg to 200g ( SS )",
  },
  {
    id: 2,
    image: "/img/prodcut2.webp",
    title: "Baumer Pressure Gauge",
    description: "Introducing our high-precision Digital Pressure Gauge, engineered to deliver unparalleled accuracy and reliability across a wide spectrum of pressure ranges. With an impressive accuracy of ± 0.05% of Full Scale (F.S.), this gauge ensures precise measurements, making it an ideal choice for demanding industrial applications where precision is paramount. ",
    subpoints:
      "1.Exceptional Accuracy: Enjoy peace of mind with precise pressure readings, thanks to the ± 0.05% F.S. accuracy of our digital gauge.  2.Versatile Range: Whether you require measurements in psi, bar, kg/cm², or any other unit, our gauge offers flexibility with its availability in all ranges. 3.Robust Construction: Built to withstand harsh industrial environments, our digital pressure gauge features a rugged construction for long-lasting durability.  4.Easy-to-Read Display: The clear digital display provides easy readability, ensuring quick and accurate pressure readings at a glance.",
  },
  {
    id: 3,
    image: "/img/prodct3.webp",
    title: "Hand Pumps",
    description:
      "Our product range includes a wide range of pneumatic calibration hand pump. Introducing our cutting-edge Pneumatic Pump, designed to deliver efficient and reliable fluid transfer capabilities in various industrial applications. ",
    subpoints:
      "1.Powerful Pneumatic Operation: Harnessing the power of compressed air, our pneumatic pump provides robust fluid transfer performance, suitable for a wide range of liquids, including oils, fuels, and hydraulic fluids.  2.Versatile Compatibility: With its adaptable design, our pump is compatible with different fluid viscosities and chemical compositions, offering versatility and flexibility in fluid handling tasks. 3.Compact and Portable: The compact and lightweight construction of our pneumatic pump enables easy maneuverability and nstallation, making it ideal for both stationary and mobile applications.Durable Construction: Built to withstand demanding operating conditions, our pump features a rugged construction and corrosion-resistant materials, ensuring long-term reliability and durability.",
  },
  {
    id: 4,
    image: "/img/product4.webp",
    title: "MEATEST M151 High Current Calibrator",
    description:
      "M151 Current Calibrator can generate up to 120 A with one year accuracy ranging from 0.035% to 0.11% at all points.",
    subpoints:
      "1.Key signal parameters including selected function, uncertainty and AC signal frequency are shown on large LCD, softkeys under the display are linked to frequently used functions for quick setup.",
  },
];
